import { WorkspacesAPITagType } from '@/api/api'
import { CollaborationRecordScoringType } from '@/types/schema/directory/collaboration-record'

const getCollaborationRecordScoringInvalidatesTags = (
  collaborationRecordScoringType: CollaborationRecordScoringType,
): WorkspacesAPITagType[] => {
  const tags = [WorkspacesAPITagType.KolManagement]

  switch (collaborationRecordScoringType) {
    case CollaborationRecordScoringType.CampaignKol:
      tags.push(WorkspacesAPITagType.CampaignCollaborationRecords)
      break
    case CollaborationRecordScoringType.ReportKol:
      tags.push(WorkspacesAPITagType.ReportCollaborationRecords)
      break
    case CollaborationRecordScoringType.Customized:
      tags.push(WorkspacesAPITagType.CustomizedCollaborationRecords)
      break
  }

  return tags
}

export default getCollaborationRecordScoringInvalidatesTags
